<section class="login-dialog">
  <!-- dialog header -->
  <div>
    <div class="login-dialog__header">
      <!-- title -->
      <h4 class="login-dialog__title">
        {{ 'global.login' | translate }}
      </h4>
      <!-- close button -->
      <button (click)="close()">
        <i class="iconsax login-dialog__icon" icon-name="x"></i>
      </button>
    </div>
  </div>
  <!-- form -->
  <form class="login-dialog__form" (submit)="login()" [formGroup]="loginForm">
    <!-- username -->

    <pwj-phone-number
      icon="phone"
      iconPosition="left"
      placeholder="global.enter_your_phone"
      label="global.phone_number"
      formControlName="mobile"></pwj-phone-number>

    <!-- password -->
    <pwj-input
      icon="lock-2"
      name="password"
      type="password"
      iconPosition="left"
      placeholder="global.enter_password"
      label="global.password"
      formControlName="password"></pwj-input>
    <div class="login-dialog__text">
      <button type="button" (click)="openForgotDialog()">{{ 'global.forgotPassword' | translate }}</button>
    </div>
    <div class="login-dialog__footer">
      <!-- dialog footer -->
      <div class="login-dialog__footer-left">
        <p class="login-dialog__footer-title">
          {{ 'global.dontHaveAccount' | translate }}
        </p>
        <!-- signup button -->
        <pwj-button
          class="header-btn"
          buttonClasses="[&>span]:!font-500"
          size="large"
          [iconReversePosition]="true"
          [rotateIconInRtl]="true"
          (click)="openSignupDialog()"
          type="button">
          {{ 'global.signup' | translate }}
        </pwj-button>
      </div>
      <!-- login button -->
      <pwj-button
        class="submit-btn"
        type="submit"
        variant="primary"
        size="medium"
        icon="chevron-right"
        buttonClasses="yektanet__login-dialog-btn"
        matomoClickCategory="Authentication"
        matomoClickAction="Login"
        matomoClickName="Form"
        [rotateIconInRtl]="true"
        [iconReversePosition]="true"
        [disabled]="
          loginForm.invalid || isDisabledSubmitBtn || formIsSubmitting
        "
        >{{ 'global.login' | translate }}</pwj-button
      >
    </div>
  </form>
</section>
